// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"23":"5b8f056a13bb8dad81d11a57e66a0f63","795":"8a4bbda9326d76392d6429ae4a33d608"}[chunkId] + ".js";
};